import { StandardIconButton } from "components";
import React from "react";
import { UserDropdown } from "routes/dashboard/components";
import { Box, Heading, HStack } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquareChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { useAppStore } from "utils/react-hooks/useAppStore.hook";
import { observer } from "mobx-react";
import { PageHeaderBreadcrumbs } from "./PageHeaderBreadcrumbs";
import { PageHeaderTourButton } from "./PageHeaderTourButton";

export interface IPageHeaderProps {
  title?: React.ReactNode;
  middleElement?: React.ReactNode;
}

export const PageHeader: React.FC<IPageHeaderProps> = observer(
  ({ title, middleElement }) => {
    const {
      uiStore: { isLeftSidebarOpen, toggleLeftSidebar },
      authStore: { authUser, removeDashboardTour },
      userAccountsStore: { selectedAccountStore },
    } = useAppStore();

    return (
      <Box
        height="70px"
        borderBottom={"1px solid"}
        borderColor={"leadpro.200"}
        px={6}
        display="flex"
        alignItems="center"
        justifyContent={"space-between"}
        style={{ flexShrink: 0 }}
        bg={"leadpro.50"}
      >
        <HStack spacing={2} align={"center"}>
          {!isLeftSidebarOpen && (
            <StandardIconButton
              aria-label={"expand-left-side-bar"}
              color={"leadpro.400"}
              icon={
                <FontAwesomeIcon icon={faSquareChevronRight} fontSize={20} />
              }
              onClick={() => toggleLeftSidebar()}
            />
          )}
          <Heading fontSize="md" fontWeight="500">
            {!!selectedAccountStore && (
              <PageHeaderBreadcrumbs
                accountStore={selectedAccountStore}
                title={title}
              />
            )}
          </Heading>
        </HStack>
        {middleElement}
        <HStack spacing={6} align={"center"}>
          {!!selectedAccountStore && (
            <PageHeaderTourButton
              accountStore={selectedAccountStore}
              removeDashboardTour={removeDashboardTour}
            />
          )}
          {!!authUser && <UserDropdown user={authUser} />}
        </HStack>
      </Box>
    );
  }
);
